module.exports = __webpack_public_path__ + "img/1-2.b80ed1f7.svg";